import _ from 'underscore';
import getLevel from '../util/get-level';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';

export function getName() {
  return 'newProductGroupsGrid';
}

export function getColumnsMetadata() {
  return _.defaults({
    ProductGroup: 'Condition',
    Bid: 'BidAmount/Bid/Amount',
    BidBoost: 'BidBoost/Multiplier',
    TrackingTemplate: 'TrackingUrlTemplate',
    CustomParameters: 'UrlCustomParameters',
    ProductsSubmitted: 'SubmittedOfferCount',
    ProductsTargeted: 'TargetedOfferCount',
  }, PerformanceMetricsColumns);
}

export function getRoute({
  CampaignId,
  AdGroupId,
  IsAdGroupTreeView,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup': {
      const baseUri = 'customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/productgroups';
      return IsAdGroupTreeView ? baseUri : `${baseUri}/flatten`;
    }
    case 'Campaign':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/productgroups';
    case 'Account':
    default:
      return 'customer/:customer_id/account/:account_id/productgroups';
  }
}

export function getRouteForNewUI({
  getUrlSearch,
  selection: {
    CampaignId,
    AdGroupId,
    IsAdGroupTreeView,
  },
}) {
  const search = getUrlSearch({
    campaignId: CampaignId,
    adGroupId: AdGroupId,
  });
  const path = AdGroupId && IsAdGroupTreeView ?
    'productgroups/hierarchy' :
    'productgroups/list';

  return `${path}${search}`;
}
